
import { Component, Prop, Vue } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";
import DialogDVF from "./dialog-dvf.vue";
import BtnBase from "./btn-base.vue";
enum LevelClass {
  "safe",
  "warning",
  "danger",
  "primary"
}

@Component({ components: { DescribeData, DialogDVF, BtnBase } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: Answer, default: () => new Answer() }) mindData!: Answer;

  visibleForDVF = false; // 阅读指引弹窗是否显示
  get result() {
    return this.mindData.tacPsycResult.result;
  }

  get LevelClass() {
    return LevelClass;
  }

  get obvervationalEvaluateLevel() {
    return this.result.obvervationalEvaluateShowList.length
      ? LevelClass.danger
      : LevelClass.safe;
  }
}
